export default {
  hotPickupSelectedPostcode: state => state.hotPickupSelectedPostcode,
  hotPickupSelectedPrefecture: state => state.hotPickupSelectedPrefecture,
  hotPickupSelectedCity: state => state.hotPickupSelectedCity,
  hotDeliverySelectedPostcode: state => state.hotDeliverySelectedPostcode,
  hotDeliverySelectedPrefecture: state => state.hotDeliverySelectedPrefecture,
  hotDeliverySelectedCity: state => state.hotDeliverySelectedCity
}



// WEBPACK FOOTER //
// ./src/vuex/modules/ui/getters.js